import React from 'react'
import { Form, Typography } from '@s4l/ds'
import { IconTrash } from '@s4l/icons/IconTrash'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import { useSearchMetadata } from '../useSearchMetadata'
import type { SearchMetadata } from '@s4l/stayforlong/property/domain/SearchMetadata'
import { FacilityID } from '@s4l/stayforlong/shared/domain/FacilityID'

const FilterFacilities = ({ metadata }: { metadata?: SearchMetadata }) => {
  const { i18n } = useS4LContext()
  const { searchMetadata: newMetadata } = useSearchMetadata()

  const searchMetadata = newMetadata || metadata

  const availableFacilities = FacilityID.getFilterableFacilities().map(facility => ({
    slug: facility.id,
    // eslint-disable-next-line s4l/require-i18n-formatmessage-id-literal
    name: i18n.formatMessage({ id: facility.translationKey }),
  }))

  return (
    <Form.Fieldset>
      <Form.Legend>{i18n.formatMessage({ id: 'filter-category.hotel-facilities' })}</Form.Legend>
      <Form.ClearButton icon={<IconTrash />}>
        {i18n.formatMessage({ id: 'serp.filter-clear' })}
      </Form.ClearButton>
      {availableFacilities.map(facility => {
        const count = searchMetadata?.facilities?.getByKey(facility.slug)?.count ?? 0
        return (
          <Form.Label key={facility.slug}>
            {facility.name}
            {searchMetadata && (
              <Typography variant="caption" size="l" color="neutral-800">
                {count}
              </Typography>
            )}
            <Form.Checkbox
              disabled={searchMetadata && !count}
              name="facilities"
              multiple
              trueValue={facility.slug}
            />
          </Form.Label>
        )
      })}
    </Form.Fieldset>
  )
}

FilterFacilities.displayName = 'SearchFilters.FilterFacilities'
export default withErrorBoundary(FilterFacilities)
